import firebase from "firebase/app";
import { db } from "../../Firebase/firebase";

export default async function registerSelection({
  uid,
  productType,
  brand = "",
  model = "",
  year: yearParam = 0,
  interactionType = "",
  utm_source,
  utm_medium,
  utm_campaign,
  utm_content,
  isAgentLogged = false,
} = {}) {
  try {
    const params = new URLSearchParams(window.location.search);
    const data = {
      uid,
      productType,
      brand,
      model,
      year: Number(yearParam),
      interactionType,
      utm_source: utm_source ?? params.get("utm_source") ?? "",
      utm_medium: utm_medium ?? params.get("utm_medium") ?? "",
      utm_campaign: utm_campaign ?? params.get("utm_campaign") ?? "",
      utm_content: utm_content ?? params.get("utm_content") ?? "",
      isAgentLogged,
      timestamp: Date.now(),
      timestampServer: firebase.firestore.FieldValue.serverTimestamp(),
    };

    if (!uid) throw new Error("UID is required to register selection");

    await db.collection("quoteSelectionEvents").add(data);
  } catch (error) {
    console.error(error);
  }
}
